import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AIIcon from '~/images/shared/AIIcon.svg';

const AIButton: React.FC<{
  action: () => void;
  text: string;
  width?: string;
}> = ({ text, width, action }) => {
  const { t, i18n } = useTranslation('common');
  const isSpanish = i18n.language === 'es';

  return (
    <div
      onClick={action}
      className={classNames(
        'flex cursor-pointer items-center justify-center gap-1 rounded-xl bg-background-200 px-12 py-16 text-white',
        width ?? 'w-fit'
      )}
      style={{
        background:
          'linear-gradient(135deg, #32A4C7 0%, #3432C7 50%, #B632C7 100%)',
      }}
    >
      <span className='text-24'>
        <AIIcon />
      </span>
      <span
        className='font-semi-bold'
        style={{ fontSize: isSpanish ? '15px' : '' }}
      >
        {text}
      </span>
      <span>-</span>
      <span className='text-12'>{t('beta')}</span>
    </div>
  );
};

export { AIButton };
